import { PropsWithChildren } from 'react';

import { PageSpinner } from './PageSpinner';

export const PageContent = ({
    children,
    isLoading,
    loadingText = 'Loading',
}: PropsWithChildren<{ isLoading?: boolean; loadingText?: string }>) => {
    if (isLoading) {
        return <PageSpinner label={loadingText} />;
    }

    return <>{children}</>;
};
